import styled from 'styled-components'

export const ActiveFiltersMenuContainer = styled.div`
  gap: 8px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`

export const ClearAllButtonContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.neutralW90};

  span {
    font-size: 14px;
    font-weight: 400;
    margin-right: 8px;
  }
`
